_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[12],{

/***/ "/EDR":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("QeBL");
      }
    ]);
  

/***/ }),

/***/ "QeBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__("h4VS");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("9ixD");

// EXTERNAL MODULE: ./src/components/Page/index.tsx + 1 modules
var Page = __webpack_require__("Nlcv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@sanity/image-url/lib/browser/image-url.umd.js
var image_url_umd = __webpack_require__("bYjO");
var image_url_umd_default = /*#__PURE__*/__webpack_require__.n(image_url_umd);

// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__("osSN");
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);

// EXTERNAL MODULE: ./client.js
var client = __webpack_require__("zCU7");

// CONCATENATED MODULE: ./src/components/PostDetailsGrid/index.tsx

var __jsx = react["createElement"];




var builder = image_url_umd_default()(client["a" /* default */]);

function urlFor(source) {
  return builder.image(source);
}

function PostDetailsGrid(_ref) {
  var posts = _ref.posts;
  if (!posts || posts.length === 0) return null;
  return __jsx("div", {
    className: "flex flex-col space-y-5"
  }, posts.map(function (_ref2) {
    var _id = _ref2._id,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title,
        _ref2$slug = _ref2.slug,
        slug = _ref2$slug === void 0 ? '' : _ref2$slug,
        _ref2$publishedAt = _ref2.publishedAt,
        publishedAt = _ref2$publishedAt === void 0 ? '' : _ref2$publishedAt,
        _ref2$description = _ref2.description,
        description = _ref2$description === void 0 ? '' : _ref2$description,
        _ref2$body = _ref2.body,
        body = _ref2$body === void 0 ? '' : _ref2$body;
    return slug && __jsx("div", {
      key: _id
    }, __jsx("div", {
      style: {
        boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)"
      },
      className: "flex flex-col p-8 border border-gray-200 bg-white dark:bg-gray-900 dark:border-gray-800 rounded-2xl space-y-4 items-center justify-center",
      key: title
    }, __jsx("div", {
      className: "flex flex-row space-x-2 items-center"
    }, __jsx("p", {
      className: "text-gray-400 text-sm"
    }, new Date(publishedAt).toDateString())), __jsx("a", {
      className: "text-gray-900 dark:text-white font-bold text-3xl mx-auto"
    }, title), __jsx("div", {
      className: "prose prose-md text-primary dark:text-gray-400 text-gray-700"
    }, __jsx(BlockContent_default.a, Object(esm_extends["a" /* default */])({
      blocks: body,
      imageOptions: {
        w: 320,
        h: 240,
        fit: 'max'
      }
    }, client["a" /* default */].config())))));
  }));
}
// EXTERNAL MODULE: ./src/components/Layouts/index.tsx
var Layouts = __webpack_require__("0m6W");

// EXTERNAL MODULE: ./node_modules/groq/lib/groq.js
var groq = __webpack_require__("dFLH");
var groq_default = /*#__PURE__*/__webpack_require__.n(groq);

// CONCATENATED MODULE: ./src/pages/index.tsx



var pages_jsx = react["createElement"];

function _templateObject() {
  var data = Object(taggedTemplateLiteral["a" /* default */])(["\n    *[_type == \"post\" && publishedAt < now()]|order(publishedAt desc)\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}









var pages_Index = function Index(_ref) {
  var posts = _ref.posts;
  return pages_jsx(Page["b" /* default */], null, pages_jsx(next_seo_module["b" /* NextSeo */], {
    title: 'Sam Shore',
    description: 'Building businesses online.',
    openGraph: {
      url: 'https://samjshore.com',
      title: 'Sam Shore',
      description: 'Building businesses online.',
      site_name: 'Sam Shore',
      images: [{
        url: 'https://samjshore.com/static/meta/home.png',
        alt: 'Sam Shore'
      }]
    }
  }), pages_jsx(Layouts["a" /* CenteredColumn */], null, pages_jsx("div", {
    className: "mx-auto flex flex-row items-center justify-center mb-8 space-x-2"
  }, pages_jsx("img", {
    src: "https://pbs.twimg.com/profile_images/1364015106934341635/RFdTKNZq_400x400.jpg",
    className: "rounded-full w-8 h-8"
  }), pages_jsx("h2", {
    className: "font-semibold text-xl"
  }, "Sam Shore")), pages_jsx("div", {
    className: "flex flex-col space-y-8"
  }, pages_jsx(PostDetailsGrid, {
    posts: posts
  }))));
};

pages_Index.getInitialProps = /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
  return regenerator_default.a.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client["a" /* default */].fetch(groq_default()(_templateObject()));

        case 2:
          _context.t0 = _context.sent;
          return _context.abrupt("return", {
            posts: _context.t0
          });

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));
/* harmony default export */ var pages = __webpack_exports__["default"] = (pages_Index);

/***/ })

},[["/EDR",0,2,1,3,4,6]]]);